import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const TimeTrackingService = {
  
  async getAllTimeTracking(filters) {
    try {
      // Utilisez les filtres pour construire l'URL de la requête
      const queryString = Object.keys(filters)
        .map((key) => `${key}=${encodeURIComponent(filters[key])}`)
        .join("&");

      const result = await axios.get(`${apiUrl}/TimeTracking/getAllTimeTracking?${queryString}`);
      if (result) {
        return result.data;

      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  },
  async setTimePrevisionaly(payload)
  {
    try{
       const result = await axios.post(`${apiUrl}/Tracking/`,{
           payload:payload
        });
          if (result) {
            return result.data;
          }
      }catch (error) {
          if (error.response) {
              return error.response.data;
          }
      }
  },
  async getTimePrevisionaly()
  {
    try{
      const result = await axios.get(`${apiUrl}/Tracking/`);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async deleteTimePrevisionaly(id)
  {
    try{
      const result = await axios.get(`${apiUrl}/Tracking/delete/`+id);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async getByIDTimePrevisionaly(id)
  {
    try{
      const result = await axios.get(`${apiUrl}/Tracking/getById/`+id);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async updateTimePrevisionaly(id,payload)
  {
    try{
      const result = await axios.put(`${apiUrl}/Tracking/`+id,{
        payload:payload
      });
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async sendvalidate(id)
  {
    try{
      const result = await axios.get(`${apiUrl}/Tracking/sendvalidate/`+id);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async getlistvalidate(debut,fin,demandeur)
  {
    try{
      const result = await axios.post(`${apiUrl}/Tracking/getlistvalidate`,{
        debut:debut,
        fin:fin,
        demandeur:demandeur
      });
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },

  async validate(id,timetracking)
  {
    try{
      const result = await axios.get(`${apiUrl}/Tracking/validatetimetracking/`+id+'/'+timetracking);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },

  
  async refused(id,observation)
  {
    try{
      const result = await axios.post(`${apiUrl}/Tracking/refusedtimetracking/`+id,
        {observation:observation}
      );
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async tousvalidate(rowsid)
  {
    try{
      const result = await axios.post(`${apiUrl}/Tracking/tousvalidate`,
        {rowsId:rowsid}
      );
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },

  async getTimeTrackingReport(filters) {
    try {
      // Utilisez les filtres pour construire l'URL de la requête
      const queryString = Object.keys(filters)
        .map((key) => `${key}=${encodeURIComponent(filters[key])}`)
        .join("&");

      const result = await axios.post(`${apiUrl}/TimeTracking/getTimeTrackingReport`, 
        filters
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  },

  async getTimeTrackingEtatHistory(filters) {
    try {
      // Utilisez les filtres pour construire l'URL de la requête
      const queryString = Object.keys(filters)
        .map((key) => `${key}=${encodeURIComponent(filters[key])}`)
        .join("&");

      const result = await axios.get(`${apiUrl}/TimeTracking/getTimeTrackingReportHistory?${queryString}`);
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  },

  async generateTimeTrackingEtatFile(filters, selectedUsers = []) {
    try {

      const result = await axios.post(`${apiUrl}/TimeTracking/generateTimetrackingReportFile`,
        {
          'directions': filters.directions,
          'services': filters.services,
          'date_debut': filters.date_debut,
          'date_fin': filters.date_fin,
          'fonctions': filters.fonctions,
          'registration_number': filters.registration_number,
          'nom': filters.nom,
          'selectedUsers': selectedUsers
        },
        { responseType: 'blob' }
      );
      if (result) {
        return result;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

  },
   async listpersonnel(direction)
  {
    try{
      const result = await axios.get(`${apiUrl}/TimeTracking/getpersonnedirection/`+direction);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
   async trackingadd(payload)
  {
    try{
      const result = await axios.post(`${apiUrl}/TimeTracking/trackingadd/`,{
        payload:payload
      });
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async trackingtousaffiche()
  {
    try{
      const result = await axios.get(`${apiUrl}/TimeTracking/jourinsert`);
         if (result) {
           return result.data;
         }
     }catch (error) {
         if (error.response) {
             return error.response.data;
         }
     } 
  },
  async getTimeTrackingFundingReport(filters, selectedUsers = []) {
    try {
      const result = await axios.post(`${apiUrl}/TimeTracking/getTimeTrackingFundingReport`,
        {
          'directions': filters.directions,
          'date_debut': filters.date_debut,
          'date_fin': filters.date_fin,
          'nom': filters.nom,
          'registration_number': filters.registration_number,
          'selectedUsers': selectedUsers
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
    async getTimeTrackingStg(direction, service, annee,mois,type) {
    try {
      const result = await axios.post(`${apiUrl}/TimeTracking/getTimeTrackingStagiaire`,
        {
          'directions': direction,
          'services': service,
          'mois': mois,
          'annee': annee,
          'type': type,
        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

    async getlistmanuel(direction, service, datedebut,datefin) {
    try {
      const result = await axios.post(`${apiUrl}/TimetrackingProvisional/getlist`,
        {
          'direction': direction,
          'services': service,
          'datedebut': datedebut,
          'datefin': datefin

        }
      );
      if (result) {
        return result.data;
      }
    }
    catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  
}
export default TimeTrackingService;